/* global modForm */
export function generateTooltipMarkup(inputName, tooltipMessage) {
	// parent div
	const parentDiv = document.createElement('div');
	parentDiv.className = 'form-group__tooltip';

	// child icon element
	const i = document.createElement('i');
	i.className = `form-group__tooltip-icon ${!modForm.opts.useSVGTooltipIcon ? 'icon-fill-question' : ''}`;
	i.setAttribute('data-bind', 'tooltip-icon');
	i.setAttribute('tooltip-name', inputName);
	i.setAttribute('role', 'button');
	i.setAttribute('tabindex', '0');
	i.setAttribute('aria-describedby', `tooltip-${inputName}`);
	if (modForm.opts.useSVGTooltipIcon) {
		const tooltipIcon = '<svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 14.375C9.30964 14.375 8.75 14.9346 8.75 15.625C8.75 16.3154 9.30964 16.875 10 16.875C10.6904 16.875 11.25 16.3154 11.25 15.625C11.25 14.9346 10.6904 14.375 10 14.375ZM11.4055 3.83267C8.95021 3.44378 7.09097 4.26344 6.18132 6.26538C5.89573 6.89389 6.17372 7.63492 6.80224 7.92051C7.43075 8.2061 8.17178 7.9281 8.45737 7.29959C8.86537 6.40166 9.5999 6.07785 11.0144 6.30189C11.7636 6.42054 12.2747 7.12403 12.156 7.87317C12.085 8.32165 11.7969 8.70604 11.3863 8.90003C9.78709 9.65563 8.76712 10.8987 8.76712 12.5C8.76712 13.1904 9.45176 13.75 10.1421 13.75C10.8325 13.75 11.2671 13.1904 11.2671 12.5C11.2671 11.9286 11.6827 11.525 12.4544 11.1604C13.6123 10.6132 14.4249 9.52915 14.6253 8.26426C14.9599 6.1514 13.5184 4.16731 11.4055 3.83267Z" fill="currentColor" /></svg>';
		i.insertAdjacentHTML('afterbegin', tooltipIcon);
	}

	// child div
	const div = document.createElement('div');
	div.classList.add('form-group__tooltip-message');
	div.setAttribute('id', `tooltip-${inputName}`);
	div.setAttribute('role', 'tooltip');
	div.innerHTML = tooltipMessage;

	// append children to parent
	parentDiv.appendChild(i);
	i.insertAdjacentElement('afterend', div);

	return parentDiv;
}
